import { useNavigate } from '@reach/router';
/* eslint-disable import/first */
import React, { useEffect, useCallback } from 'react';
import { Container, Row } from 'react-bootstrap';
import { FormattedMessage, useIntl } from 'react-intl';
/* eslint-disable import/first */
import { Redux, Slices } from 'spwa-ui-library';
const { useSelector, useDispatch } = Redux;
import Header from '../../components/Header';
const { removeApply, couponCodeApplied } = Slices.offerSlice;
const { selectFirstMenu } = Slices.menuSlice;
const { selectDefaultAddress } = Slices.addressSlice;
const { clearCart } = Slices.cartSlice;
const { cancelOrder } = Slices.orderSlice;
import { FaArrowLeft } from '@react-icons/all-files/fa/FaArrowLeft';
import { Dialog, DialogTitle, Grid, Button } from '@material-ui/core';
import { orderCompletedGA } from 'spwa-ui-library/esm/utils/helperGA';
import css from './index.module.scss';

function Payment() {
  const order = useSelector((state) => state.order);
  const dispatch = useDispatch();
  const cart = useSelector((state) => state.cart);
  const menu = useSelector(selectFirstMenu);

  const currency = menu && menu.currency;
  const categoryList = useSelector((state) => state.category);
  const offerSelected = useSelector(couponCodeApplied);
  const defaultAddress = useSelector(selectDefaultAddress);
  const intl = useIntl();
  const orderInfo = order.data?.info?.data?.orderPlaced;
  const [showDig, setShowDig] = React.useState(false);
  const navigate = useNavigate();
  window.onbeforeunload = function () {
    return 'Your upload will be lost if you leave the page, are you sure?';
  };
  // eslint:fix parseMessage is wrapped in useCallback
  const parseMessage = useCallback((e) => {
    if (e.data.type === 'transaction-complete' && e.data.message === 'success') {
      orderCompletedGA(
        cart,
        currency,
        orderInfo.orderInfo.orderType,
        categoryList,
        offerSelected,
        orderInfo.orderInfo._id,
        orderInfo.orderInfo.payment.paymentMethodId,
        defaultAddress
      );
      handleRedirect(true);
    } else if (e.data.type === 'transaction-fail' && e.data.message === 'failure') {
      handleRedirect(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => {
    window && window.addEventListener('message', parseMessage, false);
    return () => {
      window && window.removeEventListener('message', parseMessage);
    };
  }, [parseMessage]);
  const onExitMemoized = React.useCallback((e) => {
    setShowDig(true);
  }, []);
  const redirectCancel = () => {
    dispatch(cancelOrder({ id: orderInfo.orderInfo._id }));
    navigate('/cart', { replace: true });
  };
  const handleRedirect = (status) => {
    if (status) {
      dispatch(clearCart());
      window.localStorage.setItem('_PMI', orderInfo.orderInfo.payment.paymentMethodGroupId);
      window.localStorage.setItem('_MPS', orderInfo.orderInfo.payment.paymentMethodSource);
      // window.localStorage.setItem('_add', orderInfo.payment);
    }
    dispatch(removeApply());
    navigate(`/${intl.locale}/thank-you/${orderInfo.orderInfo._id}`, {
      replace: true,
      state: {
        paymentCompleted: status,
      },
    });
  };
  // eslint:fix useCallback is used in this case
  // eslint:fix [] is added and quick fix is used in this case
  const unloadCallback = useCallback(
    (event) => {
      event.preventDefault();
      event.returnValue = false;
      onExitMemoized();
      return null;
    },
    [onExitMemoized]
  );
  useEffect(() => {
    window && window.addEventListener('beforeunload', unloadCallback, false);

    return () => {
      window && window.removeEventListener('beforeunload', unloadCallback, false);
    };
  }, [navigate, unloadCallback]);

  return (
    <div className={css.root}>
      <Header
        icon={<FaArrowLeft onClick={onExitMemoized} />}
        title={<FormattedMessage id="trackorder_payments" defaultMessage="Payment" />}
      />
      <main className={css.main}>
        <div className={css.section}>
          <Container className={css.orderConfirmation}>
            <Row>
              {orderInfo && (
                <iframe
                  title={<FormattedMessage id="trackorder_payments" defaultMessage="Payments" />}
                  src={orderInfo.noonpayRedirectionUrl}
                ></iframe>
              )}
            </Row>
          </Container>
        </div>
      </main>
      {showDig && (
        <Dialog open={showDig} onClose={() => setShowDig(false)}>
          <Grid>
            <DialogTitle>
              <FormattedMessage id="cancel_order" defaultMessage="You Want to Cancel the order?" />
            </DialogTitle>
            <div className={css.cancel}>
              <Button variant="outlined" onClick={redirectCancel} color="primary" size="medium">
                Yes
              </Button>
              <Button
                variant="contained"
                onClick={() => setShowDig(false)}
                color="primary"
                size="medium"
              >
                No
              </Button>
            </div>
          </Grid>
        </Dialog>
      )}
      <footer className={css.footer}></footer>
    </div>
  );
}

export default Payment;
